import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(data) {
        const items = data.cart_data.items;
        const resultItems = data.result;

        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.cart_preview-items');
          itensCartPreview.innerHTML = '';

          items.forEach((item, index) => {
            let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let variations = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';

            // ID correto que a API quer pra deletar (do result)
            const deleteId = resultItems[index]?.id;

            let itemHTML = `
              <li class="cart-item ${item.is_gift ? 'is-gift' : ''}">
                <figure>
                  <img src="${item.image_medium}" alt="${item.name}">
                </figure>
                <div class="cart-item-content">
                  ${brandHtml}
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                  <p class="cart-item-content-qtd">Quantidade: <b>${item.quantity}</b></p>
                  ${variations}
                  <button class="delete-item-button" data-original-id="${deleteId}"></button>
                  <div class="group-quantity">
                    <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                    <span class="qtd-value">${item.quantity}</span>
                    <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
                  </div>
                </div>
              </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
            el.textContent = String(data.result.length).padStart(2, '0');
          });

          document.querySelector('.total_value_cart_preview').textContent =
            new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);

          // Atualiza eventos dos botões
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });

          document.querySelectorAll('.btn-increase').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              
              updateItemQuantity(originalId, qtdAtual + 1);
            });
          });

          document.querySelectorAll('.btn-decrease').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              if (qtdAtual > 1) {
                updateItemQuantity(originalId, qtdAtual - 1);
              } else {
                deleteCartItem(originalId); // Lembra de adaptar a função de delete também, se ela mudar pra esse payload
              }
            });
          });
        }
      }

      function deleteCartItem(id) {
        $.ajax({
          type: 'DELETE',
          url: '/api/front/cart/items/remove',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify([{ id: id }])
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            reloadCartPreview();
            updateCartPreview(data);
          }
        }).fail(function (err) {
          console.error('Erro ao remover item do carrinho:', err);
        });
      }

      function updateItemQuantity(originalId, newQty) {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        $.ajax({
          type: 'POST',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify(payload)
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          var data = jqXHR.responseJSON;
  
          if (Array.isArray(data) && data.length > 0 && data[0].stock) {
            alert(`O produto <b>"${data[0].stock.product.name}"</b> possui <b>${data[0].stock.quantity}</b> unidade[s] em estoque.`);
          } else {
            alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
          }
        
          console.error('Erro ao atualizar quantidade:', errorThrown);
        });
      }

      function reloadCartPreview() {
        $.ajax({
          type: 'GET',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json'
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);

            document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
              el.textContent = String(data.result.length).padStart(2, '0');
            });

            document.querySelector('.total_value_cart_preview').textContent =
              new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);
          }
        });
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.result) {
          updateCartPreview(data);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        try {
          const payload = JSON.parse(settings.data);
      
          const isReplacingQty = Array.isArray(payload) && payload[0]?.replace_quantity;
      
          if (
            settings.url.includes('/api/front/cart/items/?version=2') &&
            settings.type === 'POST' &&
            xhr.responseJSON &&
            Array.isArray(xhr.responseJSON.result)
          ) {
            reloadCartPreview();
      
            // Só abre o carrinho se não estiver atualizando a quantidade
            if (!isReplacingQty) {
              $('.cart-preview--overlay').addClass('active');
              $('.cart-preview').addClass('active');
              $('.shoppub-fast-buy-popup').removeClass('active');
              document.body.classList.toggle('no-scroll');
            }
          }
        } catch (e) {
          console.warn('Erro ao interpretar payload do AJAX:', e);
        }
      });
    },
  },
  mounted() {
    this.cartPreview();
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

document.addEventListener("DOMContentLoaded", function () {

    $('.cart-preview-header__close, .cart-preview__footer .btn-continue, .cart-preview--overlay ').click(function (e) {
      e.preventDefault();
      $('.cart-preview').removeClass('active');
      $('.cart-preview--overlay').removeClass('active');
      document.body.classList.remove('no-scroll');
    });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === "class") {
        const target = mutation.target;
        if (target.classList.contains("active")) {
          const elementsToRemove = target.querySelectorAll(".product-item__content--figure .product-item__options");
          const variationToRevemo = target.querySelectorAll('.product-item__content--figure .product-radio-variation')
          const btnToRevemo = target.querySelectorAll('.product-item__content--figure .col-btn-add')
          elementsToRemove.forEach(el => el.remove());
          variationToRevemo.forEach(el => el.remove());
          btnToRevemo.forEach(el => el.remove());
        }
      }
    });
  });

  document.querySelectorAll(".shoppub-fast-buy-popup").forEach(popup => {
    observer.observe(popup, { attributes: true, attributeFilter: ["class"] });
  });

  if (window.location.pathname.includes("/pagina/quem-somos/")) {
    const shoppubContainer = document.querySelector('.main-content .container-shoppub');
    if (shoppubContainer) {
      shoppubContainer.classList.add('no-container');
    }
    const titlePage = document.querySelector('.dynamic-content__title');
    if (titlePage) {
      titlePage.classList.add('no-title');
    }
  }

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      setTimeout(() => {
        const productItem = document.querySelectorAll('.product-item');
        if (productItem.length) {
          productItem.forEach((item) => {
            let optionsColors = item.querySelectorAll('.product__colors .product__colors-item');
            let more = item.querySelector('.product-item__options .more');
            if (optionsColors.length >= 5) {
              let productColors = item.querySelector('.product__colors');
              if (productColors && more) {
                productColors.appendChild(more);
              }
            }
          });
        }
      }, 500);

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
        setTimeout(() => {
          if (!el.closest("#js_buy_together_api_layout_1").length) {
            // $(el).find('.product-item__content--figure').append($(el).find('.product-item__options .col-btn-add').clone());
            // $(el).find('.product-item__content--figure').append($(el).find('.product-item__options .product-radio-variation').clone());

            const btnBuy = $(el).find('span.col-btn-add');
            const productRadioVariation = $(el).find('.product-radio-variation');

            if (btnBuy && productRadioVariation) { // Check if elements exist
              btnBuy.on('mouseenter', () => {
                productRadioVariation.addClass('active');
              });

              btnBuy.on('mouseleave', () => {
                productRadioVariation.removeClass('active');
              });
            }
          }
        }, 1000)
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      const isModalPopup = parent.classList.contains('shoppub-fast-buy-popup') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';
      let dataIdAuto = '';
      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-item__content .product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else if (isModalPopup) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;

      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        res.data.variations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail_${dataIdAuto}_${res.data.id}" id="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" value="${variation.id}" data-id-auto="${dataIdAuto}" data-variation-name="${variation.main_attribute.name}" data-origin-location="product_detail">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        const figure = parent.querySelector('.product-item__content .product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else if (isModalPopup) {
        const figure = parent.querySelector('.product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-fancybox="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
          });
        }
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }

  document.body.addEventListener('click', function (event) {
    const clickedColor = event.target.closest('.product__colors-item, .product__colors-box');
    if (!clickedColor) return;
  
    const isProductItem = !!event.target.closest('.product-item');
    const isModalPopup = !!event.target.closest('.shoppub-fast-buy-popup');
  
    if (isProductItem || isModalPopup) {
      event.preventDefault();
  
      const productItem = isProductItem
        ? (event.target.closest('.product-item') || event.target.closest('.product-detail__header'))
        : event.target.closest('.shoppub-fast-buy-popup');
  
      const targetColor = clickedColor.classList.contains('product__colors-item')
        ? clickedColor
        : clickedColor.closest('.product__colors-item');
  
      if (!productItem || !targetColor) return;
  
      if (isProductItem) {
        const colorsContainer = productItem.querySelector('div.product__colors');
        if (colorsContainer) {
          const options = colorsContainer.querySelectorAll('.product__colors-item');
         // Remove 'is-selected' de todos os botões no mesmo productItem
          const allColorOptions = productItem.querySelectorAll('.product__colors-item');
          allColorOptions.forEach(option => {
            option.classList.remove('is-selected');
          });
        }
        targetColor.classList.add('is-selected');
      }
  
      const selected = targetColor.getAttribute('variation-id');
      selectVariation(selected, productItem);

      if(isModalPopup){
        const figureModal = document.querySelector('.product-item__content--figure');
        const name = document.querySelector('.product-item__content--figcaption-name');
        figureModal.appendChild(name);
      }
    }
  })
});